import React, {Component} from 'react';
import {connect} from 'react-redux';
import moment from 'moment';
import {Card, Grid, Table, Icon, Loader} from 'semantic-ui-react';
import {Actions} from '../../../common/actions';
import {fullDate} from '../../../common/constants/datesFormat';
import ExportButton from './partExportButton';

class LostSalesDetail extends Component {
  constructor(props) {
    super(props);
    this.handleExportClick = this.handleExportClick.bind(this);
    this.handleClose = this.handleClose.bind(this);
  }

  handleExportClick() {
    const {selectedPart, initialDate, finalDate, reason, partCode, agency, user, dealer} = this.props;
    this.props.getPartLostSalesReport(selectedPart, {
      initialDate, finalDate, reason, partCode, agency, user, dealer,
    });
  }

  handleClose() {
    this.props.clearLostSalesSelectedPart();
  }

  renderLostSalesDetail() {
    const {detail, loading} = this.props;

    if (loading) {
      return (
        <Table.Row>
          <Table.Cell colSpan='100%'>
            <Loader active inline='centered' />
          </Table.Cell>
        </Table.Row>
      );
    }

    return detail.map((lostSale, index) => {
      return (
        <Table.Row key={index}>
          <Table.Cell>{index + 1}</Table.Cell>
          <Table.Cell>{lostSale.dealer}</Table.Cell>
          <Table.Cell>{lostSale.agency}</Table.Cell>
          <Table.Cell>{lostSale.user.toUpperCase()}</Table.Cell>
          <Table.Cell>
            {lostSale.date ? moment(lostSale.date).format(fullDate) : null}
          </Table.Cell>
          <Table.Cell textAlign='right'>{lostSale.quantity}</Table.Cell>
          <Table.Cell>{lostSale.reason}</Table.Cell>
        </Table.Row>
      );
    });
  }

  render() {
    const {loading, selectedPart} = this.props;

    if (!selectedPart && !loading) {
      return null;
    }

    const {partCode, description} = selectedPart || {};

    return (
      <Card raised fluid className='lost-sales-part-detail'>
        <Grid>
          <Grid.Row verticalAlign='middle'>
            <Grid.Column textAlign='left' width='8'>
              <h2>{partCode} - {description}</h2>
            </Grid.Column>
            <Grid.Column textAlign='right' width='8'>
              <ExportButton />
              <Icon link name='close' color='red' size='big' onClick={this.handleClose} />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column>
              <Table striped>
                <Table.Header>
                  <Table.Row>
                    <Table.HeaderCell>Evento No.</Table.HeaderCell>
                    <Table.HeaderCell>Concecionario</Table.HeaderCell>
                    <Table.HeaderCell>Agencia</Table.HeaderCell>
                    <Table.HeaderCell>Usuario</Table.HeaderCell>
                    <Table.HeaderCell>Fecha</Table.HeaderCell>
                    <Table.HeaderCell>Cantidad</Table.HeaderCell>
                    <Table.HeaderCell>Motivo</Table.HeaderCell>
                  </Table.Row>
                </Table.Header>
                <Table.Body>
                  {this.renderLostSalesDetail()}
                </Table.Body>
              </Table>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Card>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'loading': state.lostSalesReportDetail.loadingDetail,
    'detail': state.lostSalesReportDetail.lostSalesDetail,
    'selectedPart': state.lostSalesReportDetail.selectedPart,
    'initialDate': state.lostSalesReportDetail.initialDate,
    'finalDate': state.lostSalesReportDetail.finalDate,
    'dealer': state.lostSalesReportDetail.dealer,
    'agency': state.lostSalesReportDetail.agency,
    'user': state.lostSalesReportDetail.user,
    'reason': state.lostSalesReportDetail.reason,
  };
};

const {clearLostSalesSelectedPart} = Actions;

export default connect(mapStateToProps, {clearLostSalesSelectedPart})(LostSalesDetail);
